// extracted by mini-css-extract-plugin
export default {"MoveButton":"_MoveButton--H7B4l"};